export default {
	title: "Cadastrar Templo",
	subtitle: "Crie sua conta e cadastre seu templo",
	brandingTitle: "Gerencie seu Templo",
	brandingDesc: "Sistema completo para gestão de templos de Umbanda",
	confirmPassword: "Confirmar senha",
	templeName: "Nome do Templo",
	templeNameHint: "Inicial maiúscula em cada palavra (ou tudo em maiúsculas)",
	acronym: "Sigla",
	acronymHint: "2-10 caracteres em maiúsculas, será usada na URL do templo",
	submit: "Cadastrar Templo",
	success: "Cadastro realizado! Verifique seu email para ativar a conta.",
	error: "Erro ao cadastrar. Tente novamente.",
	subscribingNotice: "Você está iniciando a assinatura de um plano. Após criar a conta e confirmar o e-mail, você revisa o plano e finaliza o pagamento.",
};
